import { AdminConsolePageDetails } from "../../../../../../../types/adminConsoleTypes";
import { useTranslation } from "react-i18next";
import useAppDispatch from "../../../../../../../hooks/redux/base/useAppDispatch";
import React, { Fragment, useState } from "react";
import {
  openDeleteModal,
  openEditModal,
} from "../../../../../../../store/redux/slice/ComponentsControl/adminConsoleConfigControl";
import { adminConsoleSection } from "../../../../../../../utils/constants";
import { acPageCreationInitialValues } from "../../../../../../../init/adminConsoleCreationInitialValues";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { Box, Collapse, IconButton, Table, TableBody, TableHead, Typography } from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import {
  AlertSpg,
  isArrayEmpty,
  isArrayNotEmpty,
  isEmpty,
  OptionTableCell,
  TableButton,
} from "@duosoftbg/nacid-components";

type AdminConsolePageProps = {
  page: AdminConsolePageDetails;
  depth: number;
  childrenPages?: number;
};

const AdminConsolePage = ({ page, depth, childrenPages }: AdminConsolePageProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [openPage, setOpenPage] = useState(false);
  const children = page.children;
  const MAX_DEPTH = 2;
  const SINGLE_RESULT_LEN = 1;
  const isLevelPermitted = isEmpty(page.href) && depth < MAX_DEPTH;
  const showDelete = childrenPages ? childrenPages !== SINGLE_RESULT_LEN : true;

  const handleEditPage = (page) => {
    dispatch(openEditModal({ section: adminConsoleSection.page, object: page }));
  };

  const handleDeletePage = (id) => {
    dispatch(openDeleteModal({ section: adminConsoleSection.page, id }));
  };

  const handleCreateChildren = (parentId) => {
    dispatch(
      openEditModal({
        section: adminConsoleSection.page,
        object: { ...acPageCreationInitialValues, parentId },
      }),
    );
  };

  return (
    <Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell align="center">
          {isLevelPermitted && (
            <IconButton aria-label="expand row" size="small" onClick={() => setOpenPage(!openPage)}>
              {openPage ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </IconButton>
          )}
        </TableCell>

        <TableCell>{page.id}</TableCell>
        <TableCell>{page.title}</TableCell>
        <TableCell>{page.titleEn}</TableCell>
        <TableCell align="center">{page.position}</TableCell>
        <OptionTableCell>
          <TableButton type={"edit"} onClick={() => handleEditPage(page)} />
          {showDelete && (
            <TableButton
              onClick={() => {
                handleDeletePage(page.id);
              }}
              type={"remove"}
            />
          )}
        </OptionTableCell>
      </TableRow>
      {isLevelPermitted && (
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={openPage} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <Typography variant="h6" gutterBottom component="div">
                  {t("l.table.head.pages")}
                </Typography>
                <Table size="small">
                  <TableHead style={{ background: "#eee" }}>
                    <TableRow>
                      <TableCell style={{ width: 35 }} />
                      <TableCell>{t("l.table.head.id")}</TableCell>
                      <TableCell>{t("l.table.head.children")}</TableCell>
                      <TableCell>{t("l.table.head.children.en")}</TableCell>
                      <TableCell>{t("l.table.head.position")}</TableCell>
                      <TableCell align="right">
                        <TableButton type={"create"} onClick={() => handleCreateChildren(page.id)} />
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  {isArrayNotEmpty(children) && (
                    <TableBody>
                      {children.map((child) => (
                        <AdminConsolePage
                          key={child.id}
                          page={child}
                          depth={depth + 1}
                          childrenPages={children.length}
                        />
                      ))}
                    </TableBody>
                  )}
                </Table>
                {isArrayEmpty(children) && <AlertSpg severity="info">{t("m.empty.list")}</AlertSpg>}
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      )}
    </Fragment>
  );
};
export default AdminConsolePage;
